import { z } from "zod";
import type { BrandProfile } from "./business";

export function googleMapsUrl(value: string): string | null {
  try {
    const url=new URL(value);
    if(url.protocol!=="https:" || url.username || url.password || url.port || value.length>2048) return null;
    const mapPath=url.pathname==="/maps" || url.pathname.startsWith("/maps/");
    if((url.hostname==="www.google.com" && mapPath) || (url.hostname==="maps.google.com" && (mapPath || url.pathname==="/")) || url.hostname==="maps.app.goo.gl" || (url.hostname==="goo.gl" && url.pathname.startsWith("/maps/"))) return url.href;
  } catch { /* Invalid input never becomes a link. */ }
  return null;
}

export function googleMapsEmbedUrl(value: string): string | null {
  try {
    const url=new URL(value);
    if(value.length>5000 || url.protocol!=="https:" || url.hostname!=="www.google.com" || url.port || url.username || url.password || url.pathname!=="/maps/embed" || url.hash || !url.searchParams.get("pb")?.startsWith("!")) return null;
    if([...url.searchParams.keys()].some(key=>!["pb","hl"].includes(key)) || url.searchParams.getAll("pb").length!==1) return null;
    return url.href;
  } catch { return null; }
}

/** Keep only the src from Google's Share/Embed HTML; never render supplied HTML or attributes. */
export function extractGoogleMapsEmbed(value: string): string {
  const input=value.trim();
  const match=input.match(/^<iframe\b[^>]*\bsrc\s*=\s*(["'])([^"']+)\1[^>]*>\s*<\/iframe>$/i);
  const candidate=match?.[2]?.replace(/&amp;/g,"&") || input;
  return googleMapsEmbedUrl(candidate) || input;
}

export const googleMapsLinkSchema=z.string().trim().max(2048).refine(value=>!value || Boolean(googleMapsUrl(value)),"Use a Google Maps https:// link");
export const googleMapsEmbedSchema=z.string().trim().max(5000).refine(value=>!value || Boolean(googleMapsEmbedUrl(value)),"Use Google Maps Share → Embed a map code or its https://www.google.com/maps/embed?pb= link");

export function mapsSearchUrl(place: string): string { return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(place)}`; }
export function brandMapSettings(profile: BrandProfile) {
  const address=profile.publishAddress ? profile.address : profile.location;
  return {showMap:Boolean(profile.showLocation && address.trim()),mapsUrl:profile.showLocation ? googleMapsUrl(profile.mapsUrl) || mapsSearchUrl(address) : "",mapEmbedUrl:profile.showLocation ? googleMapsEmbedUrl(profile.mapEmbedUrl) || "" : ""};
}
